module.exports = "/assets/data/9903e12b8473b70e223cc6d98013e1d8-RH19.data.json";